import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Box)<{
  disableGutters?: boolean;
  variantColor: 'light' | 'dark';
}>`
  min-height: 400px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: start;
  .swiper {
    overflow: hidden;
    width: 100%;
  }
  .swiper-button {
    &-prev,
    &-next {
      display: none;
    }

    &-prev.swiper-button-disabled,
    &-next.swiper-button-disabled {
      display: none;
    }
  }

  ${({ disableGutters, theme, variantColor }) => css`
    ${disableGutters &&
    css`
      ${theme.media.md.up} {
        padding-inline: 0;
      }
    `}

    ${theme.mediaQueries.md} {
      .swiper-button {
        &-prev,
        &-next {
          color: ${variantColor === 'light'
            ? theme.colors.white
            : theme.colors.black};
          display: initial;
          top: 45%;
          transform: translateY(-48%);

          ::after {
            font-size: 30px;
          }
        }

        &-prev {
          left: 0;
          text-align: left;
        }

        &-next {
          right: 0;
          text-align: right;
        }
      }
    }
  `}
`;

export const Title = styled(Typography)`
  text-transform: uppercase;
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.h4};
    padding-bottom: ${theme.spacing(3)};
  `}
`;

export const StyledSwiper = styled(Swiper)<{
  $hideNavigation: boolean;
  $separator: boolean;
}>`
  .swiper {
    ${({ $hideNavigation, $separator, theme }) => css`
      ${$hideNavigation &&
      css`
        &-button-prev,
        &-button-next {
          display: none;
        }
      `}
      &-slide {
        ${theme.media.md.up} {
          &-visible {
            ::before {
              content: '';
              position: absolute;
              height: 130px;
              left: -55px;
              top: 35%;
              transform: translateY(-35%);
              width: 0;
              background-color: ${theme.colors.defaultAdd5};
              display: ${$separator ? 'block' : 'none'};

              &:nth-child(n + 1) {
                width: 20px;
              }
            }

            ${theme.media.lg.up} {
              ::before {
                top: 32%;
                right: -60px;
                height: 140px;
              }
            }
          }

          &-active::before {
            display: none;
          }
        }
      }

      &-scrollbar {
        background: ${({ theme }) => theme.colors.primaryDark};
        height: 2px;
        bottom: 0;
        width: 100%;
        &-drag {
          background: ${({ theme }) => theme.colors.primary};
        }
      }
    `}
  }
`;

export const Navigation = styled.span<{ type: 'next' | 'prev' }>`
  position: absolute;
  z-index: 1;
  top: 30%;
  transform: translateY(-50%);
  pointer-events: all;
  background: #ffffff;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${({ theme, type }) => css`
    height: ${theme.spacing(5)};
    width: ${theme.spacing(5)};
    ${type === 'next' ? 'right' : 'left'}: -30px;
    ${theme.media.md.down} {
      ${type === 'next' ? 'right' : 'left'}: -16px;
    }
  `}

  :hover {
    cursor: pointer;
  }

  svg {
    height: 24px;

    path {
      fill: ${({ theme }) => theme.colors.black};
    }
  }

  &.swiper-button {
    &-disabled {
      display: none;
      svg path {
        fill: ${({ theme }) => theme.colors.defaultAdd4};
      }
      &:hover {
        cursor: not-allowed;
      }
    }
  }
`;
